__turbopack_context__.v({
  "cgu": "FamilyMiniBookSection-module__fISkua__cgu",
  "cgv": "FamilyMiniBookSection-module__fISkua__cgv",
  "contentContainer": "FamilyMiniBookSection-module__fISkua__contentContainer",
  "contentWrapper": "FamilyMiniBookSection-module__fISkua__contentWrapper",
  "coverImage": "FamilyMiniBookSection-module__fISkua__coverImage",
  "familyMiniBookSection": "FamilyMiniBookSection-module__fISkua__familyMiniBookSection",
  "form": "FamilyMiniBookSection-module__fISkua__form",
  "imageCoverWrapper": "FamilyMiniBookSection-module__fISkua__imageCoverWrapper",
  "input": "FamilyMiniBookSection-module__fISkua__input",
  "title": "FamilyMiniBookSection-module__fISkua__title",
  "titleHighlight": "FamilyMiniBookSection-module__fISkua__titleHighlight",
});
